import axios from 'axios'
import store from '../store'
import router from '../router'
import Vue from 'vue'
import vueAxios from 'vue-axios'

// Request interceptor
axios.interceptors.request.use(request => {
    const token = store.getters['auth/token']
    if (token) {
        request.headers.common['Authorization'] = `Bearer ${token}`
    }

    Vue.prototype.$loading.show();

    return request
})

const excludedURLs = ["/oauth/token"];

// Response interceptor
axios.interceptors.response.use(response => {

    const status = response.status;
    const method = response.config.method;
    const url = response.config.url;

    if (excludedURLs.includes(url)) return Promise.resolve(response);

    if (status === 200 || status === 201) {
        if (['post', 'put', 'delete'].includes(method))
            Vue.prototype.$snackbar.success("Operation completed.");
    }

    Vue.prototype.$loading.hide();
    return Promise.resolve(response);

}, error => {
    const { status } = error.response

    if (status >= 500) {
        Vue.prototype.$snackbar.error('Could not complete the request.');
    }

    if (status === 401 && store.getters['auth/check']) {
        store.commit('auth/clean');
        router.push('/login');
    }

    Vue.prototype.$loading.hide();
    return Promise.reject(error)
})

Vue.use(vueAxios, axios)


